import { useQuery } from 'react-query';
import { UseQueryResult } from 'react-query';

import { APIErrorResponse } from '@bighealth/api';
import { read_bulk } from '@bighealth/api/SceneSetGraph/v1';

import { useQueryProgram } from './useQueryProgram';

export const useQueryHomeScreen = (): UseQueryResult<
  read_bulk.Response,
  APIErrorResponse
> => {
  const programResult = useQueryProgram();
  const sceneSetGraphIds = programResult.data?.result?.scene_set_graph_ids;

  const result = useQuery<read_bulk.Response, APIErrorResponse>({
    queryKey: read_bulk.queryKey,
    queryFn: () =>
      read_bulk({
        entity_ids: sceneSetGraphIds as number[],
      }),
    enabled: typeof sceneSetGraphIds !== 'undefined',
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    cacheTime: Infinity,
    retry: false,
  });
  return result;
};
